import React, { PureComponent } from 'react';
import { fixCurrency } from 'appSrc/utils/random';
import style from './styles/style.module.css';

class SelectionOptionCard extends PureComponent {
    render() {
        const { product } = this.props;
        return (
            <div
            onClick={ this.props.onClick }
            className={ style.optionCard }
            style={ this.props.style }>
                <label>
                    <div className={ style.imageWrapper }>
                        <img src={ product.imageArr[ 0 ] } />
                    </div>
                    <div className={ style.details }>
                        <p title={ product.title }>{ product.title }</p>
                        <p>${ fixCurrency( product.price ) }</p>
                        <p className={ style.errorBlock }>{ this.props.error }</p>
                    </div>
                    <div className={ style.radioWrapper }>
                        <input type='radio' name='selectedProduct' value={ this.props.value } defaultChecked={ this.props.defaultChecked } />
                    </div>
                </label>
            </div>
        );
    }
}
SelectionOptionCard.defaultProps = {
    error: ' ',
};

export default SelectionOptionCard;
